import React from "react"

const LeadsContext = React.createContext({})

const { Provider, Consumer } = LeadsContext

export { Provider, Consumer, LeadsContext }
